module.exports = __webpack_public_path__ + "img/logo skear_2016.4eb9e949.png";